import NutakuBridge from "./NutakuBridge"
import {onNutakuEvent} from "./NutakuEvents"
import {store} from "../../store";
import {AuthActionCreators} from "../../store/reducers/auth/action-creators";

class NutakuService {

    buyItem(item: any) {

        NutakuBridge.createPayment({
            sku: item.sku,
            name: item.name,
            price: item.price,
            imageUrl: item.image,
            description: item.description || "",
            customData: JSON.stringify({
                itemId: item.id
            })
        })
    }

    init() {

        onNutakuEvent("nutaku-payment-created", (payload) => {

            console.log("Payment created", payload)

            if (payload.canBeCompletedWithoutBrowser) {

                store.dispatch(AuthActionCreators.setSystemMessage({
                    isVisible: true,
                    type: 'dialog',
                    text: `Buy ${payload.name} for ${payload.price} Nutaku Gold?`,
                    action: () => {
                        NutakuBridge.confirmPendingPayment()
                    },
                    actionCancel: () => {
                        store.dispatch(AuthActionCreators.setIsLoading(false));
                    }
                }));

            } else {

                NutakuBridge.openPendingPaymentInBrowser()

            }
        })


        onNutakuEvent("nutaku-payment-complete", () => {

            console.log("Payment completed")

            // @ts-ignore
            store.dispatch(AuthActionCreators.updateUser());

            store.dispatch(AuthActionCreators.setIsLoading(false));

        })


        onNutakuEvent("nutaku-payment-cancel", () => {

            console.log("Payment cancelled");
            store.dispatch(AuthActionCreators.setIsLoading(false));

            store.dispatch(AuthActionCreators.setSystemMessage({
                isVisible: true,
                type: 'info',
                text: 'Payment cancelled',
                action: null,
            }));

        })


        onNutakuEvent("nutaku-payment-error", (payload) => {

            console.error("Payment error", payload);
            store.dispatch(AuthActionCreators.setIsLoading(false));
            store.dispatch(AuthActionCreators.setSystemMessage({
                isVisible: true,
                type: 'info',
                text: 'Payment error',
                action: null
            }));

        })

    }

}

export default new NutakuService()